import css_anshrckf0a from './css/Playlist.css';
import Div from './Div.js';
import eventOptions from '../Functions/eventOptions.js';
import Items from './Items.js';
import Title from './Title.js';

const css = css_anshrckf0a;

/**
 * @namespace IScroll
 */

export default class Playlist extends Div
{
	constructor(parentElement)
	{
		super(parentElement);

		this.items = new Items(this);
		this.title = new WrappedTitle(this);

		config.playlistCache[config.key].then
		(
			playlist =>
			{
				this.items.loadItems(playlist);
			}
		);

		config.scripts.iScroll.then
		(
			() =>
			{
				this.element.addEventListener
				(
					'touchmove',
					event =>
					{
						event.preventDefault();
					},
					eventOptions({passive:false})
				);
				// noinspection JSUnresolvedFunction

				const iScroll = new(IScroll)
				(
					this.element,
					{
						mouseWheel: true,
						scrollbars: true,
						interactiveScrollbars: true,
						disablePointer: true,
						disableTouch: false,
						preventDefault: false
					}
				);

				new ResizeObserver
				(
					() => iScroll.refresh()
				)
				.observe(this.items.element);
			}
		);
	}

	get cssText()
	{
		return css;
	}
}

class WrappedTitle extends Title
{
	constructor(parentElement)
	{
		super(parentElement);

		this.title = new Title(this);
	}

	get value()
	{
		return this.title.value;
	}

	set value(v)
	{
		this.title.value = v;
	}
}
